export const findSelectedCountryObj = (allCountries, selectedCountry, variableToFind) => {
  const index = allCountries.findIndex((x) => x[variableToFind] === selectedCountry)
  const obj = allCountries[index]
  return obj
}
